export default __webpack_public_path__ + "static/media/Screenshot 2021-07-03 192803.1678d0a7.jpg";